import { joinGroupConstants as jg } from "./constants"

const initialState = {
    loading: false,
    error: null,
    success: false,
    joinedGroup: null
}

export function joinGroup(state = initialState, action) {
    switch (action.type) {
        // Access
        case jg.ADD_MEMBER_TO_GROUP_REQUEST: {
            return {
                ...state,
                loading: true,
                success: false,
                joinedGroup: null,

            }
        }
        case jg.ADD_MEMBER_TO_GROUP_SUCCESS: {
            return {
                ...state,

                loading: false,
                success: true,
                joinedGroup: { ...action.response }
            }
        }
        case jg.ADD_MEMBER_TO_GROUP_FAILURE: {
            return {
                ...state,
                error: action.error,
                success: false,
                loading: false,
                joinedGroup: null,

            }
        }

        default:
            return state
    }
}
